import * as PropTypes from 'prop-types';
import { customerPropType } from '../../proptypes';
import { getPageUrl } from '../../components/CrossModuleLink/utils';
import { modules, modulesMetaData } from '../../components/CrossModuleLink/modules';

export const headerPropTypes = {
	isAuthenticated: PropTypes.bool,
	isLoginPage: PropTypes.bool,
	customer: customerPropType,
};

export const getDashboardPageUrl = () => {
	return getPageUrl({
		module: modules.DASHBOARD,
		route: modulesMetaData[modules.DASHBOARD].index,
	});
};

export const PAGE_HEADER_CLASS = 'app__body-header';
export const PAGE_HEADER_STICKY_CLASS = 'app__body-header--sticky';
